import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Heart } from "lucide-react";
import { Button } from "@/components/ui/button";

const LANGS = [{ c: "fr", l: "FR" }, { c: "en", l: "EN" }, { c: "es", l: "ES" }, { c: "de", l: "DE" }];

export function MobileMenu({ open, links, user, favs, flagsV3, dashLink, onClose, onNav, onLogout }) {
  const { t, i18n } = useTranslation();
  if (!open) return null;

  return (
    <div className="lg:hidden bg-white border-t border-border px-4 py-4 space-y-2 animate-fade-up">
      {links.map((l) => (
        <Link key={l.to} to={l.to} onClick={onClose} data-testid={`mobile-nav-${l.to.replace("/", "") || "home"}`}
          className="block py-2 font-body font-semibold text-ink">{l.label}</Link>
      ))}
      <div className="flex gap-1 py-2">
        {LANGS.map((lg) => (
          <button key={lg.c} onClick={() => i18n.changeLanguage(lg.c)}
            className={`px-3 py-1 rounded-full text-xs font-bold ${i18n.language === lg.c ? "bg-canard text-white" : "bg-sand text-muted2"}`}>{lg.l}</button>
        ))}
      </div>
      {flagsV3 && (
        <button data-testid="mobile-fav-count" onClick={() => { onClose(); onNav("/mes-favoris"); }}
          className="w-full flex items-center justify-between py-2 font-body font-semibold text-ink">
          <span className="inline-flex items-center gap-2"><Heart className={`w-5 h-5 ${favs.length ? "fill-red-500 text-red-500" : "text-muted2"}`} /> {t("activities.favorites")}</span>
          {favs.length > 0 && <span data-testid="mobile-fav-badge" className="bg-red-500 text-white text-xs font-bold rounded-full min-w-[20px] h-5 px-1.5 flex items-center justify-center">{favs.length}</span>}
        </button>
      )}
      {user ? (
        <>
          <Button className="w-full rounded-full bg-canard" onClick={() => { onClose(); onNav(dashLink); }}>{t("nav.dashboard")}</Button>
          <Button variant="outline" className="w-full rounded-full" onClick={onLogout}>{t("nav.logout")}</Button>
        </>
      ) : (
        <>
          <Button variant="outline" className="w-full rounded-full" onClick={() => { onClose(); onNav("/register?role=loueur"); }}>{t("nav.loueur")}</Button>
          <Button className="w-full rounded-full bg-canard" onClick={() => { onClose(); onNav("/login"); }}>{t("nav.login")}</Button>
        </>
      )}
    </div>
  );
}
